module.exports = __webpack_public_path__ + "media/images/landing/studies/sq1-531a97b5ee4dfaca8d831f4ec4446993.jpg";